export default __webpack_public_path__ + "static/media/ic_all.501eddf5.svg";